import React from 'react';
import { Group, useMantineTheme, Flex } from '@mantine/core';
import { upperFirst } from '@mantine/hooks';

import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { getContestThumbnail } from '~/domains/contest/domains/common/utils/getContestThumbnail';
import { LinkNew } from '~/domains/common/components/Link/Link';
import { Routes } from '~/domains/common/constants/routes';
import { Avatar } from '~/domains/design-system/Avatar';
import { Title } from '~/domains/design-system/Title';
import { Text } from '~/domains/design-system/Text';

import useStyles from './columns.styles';

function ContestTitleColumn({ contest }: { contest: Contest }) {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  return (
    <Group noWrap className={classes.topLeftSlot}>
      <Avatar
        handle={contest.commissioner.handle || contest.commissioner.username}
        size="md"
        src={getContestThumbnail({
          contestThumbnailUrl: contest.thumbnail_url,
          createdByAdmin: contest.created_by_admin,
          avatarUrl: contest.commissioner.avatarUrl,
        })}
      />

      <div className={classes.titleWrapper}>
        <Title
          tag="h4"
          variant="headline-medium"
          truncate
          maw={{ base: '300px', lg: '400px', xl: '100%' }}
        >
          {upperFirst(contest.name)}
        </Title>
        <Flex gap={theme.other.spacing._4} wrap={{ base: 'wrap', md: 'nowrap' }} align="center">
          <LinkNew
            onClick={(e) => e.stopPropagation()}
            href={Routes.channel(contest.commissioner.handle)}
            sx={{ color: theme.colors.gray[6] }}
          >
            <Text component="span" size={theme.fontSizes.xs} display="block" truncate>
              {contest.commissioner.username
                ? `@${contest.commissioner.handle || contest.commissioner.username}`
                : 'Unnamed'}
            </Text>
          </LinkNew>
        </Flex>
      </div>
    </Group>
  );
}

export default ContestTitleColumn;
